import index from "./incentiveStandby.vue";
// import detail from "./requestLeaveDetail.vue";

let routesIncentiveStandby = [
    {
      path: '',
      meta: {
        title: "Chain System",
      },
      name: "incentiveStanby",
      component: index
    },
    // {
    //   path: 'detail/:id',
    //   meta: {
    //     title: "Chain System",
    //   },
    //   name: "requestLeaveDetail",
    //   component: detail
    // },
    
   
]

export default routesIncentiveStandby
  